import { Hr, Typography } from "best-common-react";
import React from "react";
import RelatedVideo from "./RelatedVideo";

type RelatedVideosProps = {
  relatedFiles: string[] | number[];
};

const RelatedVideos: React.FC<RelatedVideosProps> = ({ relatedFiles }) => (
  <div>
    <Typography variant="displaySmall">Related Videos</Typography>
    <Hr />
    <div>
      {!!relatedFiles?.length ? (
        <>
          {relatedFiles.map((fileId: string | number) => (
            <div key={fileId}>
              <RelatedVideo key={fileId} fileId={fileId} />
            </div>
          ))}
        </>
      ) : (
        <div> There are no related videos</div>
      )}
    </div>
  </div>
);

export default RelatedVideos;
